/**
 * Intelligems A/B — bundle offer banner (all product pages with Sternify box)
 *
 * Control (Test A, default): existing Sternify discount box.
 * Group 1 (Test B): stock-urgency bundle banner layout.
 *
 * Intelligems inject (Group 1):
 *   document.body.setAttribute('data-ig-bundle-offer-banner', 'true');
 */
(function () {
  'use strict';

  if (window.__igBundleOfferBannerBooted) return;
  window.__igBundleOfferBannerBooted = true;

  var ATTR = 'data-ig-bundle-offer-banner';
  var STYLE_ID = 'ig-bundle-offer-banner-ab-styles';
  var MARK = 'data-ig-bundle-offer-banner-mounted';
  var TAG_ICON =
    'https://cdn.shopify.com/extensions/019f284c-1688-759e-bf85-9a58745a9559/sternify-1518/assets/tag.png';
  var CONTROL_SELECTORS = [
    '.shopify-app-block[id*="sternify_discount_code_box"]',
    '[id*="sternify_discount_code_box"]',
  ];

  function isTestBEnabled() {
    var value = (document.body && document.body.getAttribute(ATTR) || '').trim().toLowerCase();
    return value === 'true' || value === '1' || value === 'on' || value === 'yes';
  }

  function getControlBlocks() {
    var nodes = [];
    CONTROL_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        if (nodes.indexOf(node) === -1) nodes.push(node);
      });
    });
    return nodes;
  }

  function getBannerForControl(controlBlock) {
    var next = controlBlock.nextElementSibling;
    if (next && next.matches('[data-ig-bundle-offer-banner-b]')) return next;
    return controlBlock.parentElement
      ? controlBlock.parentElement.querySelector('[data-ig-bundle-offer-banner-b][data-ig-bundle-offer-banner-for="' + controlBlock.id + '"]')
      : null;
  }

  function formatBodyHtml(html) {
    return String(html || '')
      .replace(/\s*Hurry, stock is running out!\s*/gi, '')
      .trim();
  }

  function buildBanner(controlBlock) {
    var textEl = controlBlock.querySelector('.st_discount-text');
    var iconEl = controlBlock.querySelector('.st_discount-icon');
    var iconSrc = (iconEl && iconEl.getAttribute('src')) || TAG_ICON;
    var bodyHtml = textEl ? formatBodyHtml(textEl.innerHTML) : '';

    var banner = document.createElement('div');
    banner.className = 'ig-bundle-offer-banner-b';
    banner.setAttribute('data-ig-bundle-offer-banner-b', '');
    if (controlBlock.id) {
      banner.setAttribute('data-ig-bundle-offer-banner-for', controlBlock.id);
    }

    banner.innerHTML =
      '<div class="ig-bundle-offer-banner-b__left">' +
      '<div class="ig-bundle-offer-banner-b__icon-wrap" aria-hidden="true">' +
      '<img src="' + iconSrc + '" alt="" width="26" height="26" loading="lazy">' +
      '</div>' +
      '<div class="ig-bundle-offer-banner-b__stock">' +
      '<span>Stock: Low</span>' +
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2Zm1 11h4v-2h-3V7h-2v6Z" fill="currentColor"/>' +
      '</svg>' +
      '</div>' +
      '<div class="ig-bundle-offer-banner-b__progress" role="presentation">' +
      '<div class="ig-bundle-offer-banner-b__progress-fill"></div>' +
      '</div>' +
      '</div>' +
      '<div class="ig-bundle-offer-banner-b__right">' +
      '<h3 class="ig-bundle-offer-banner-b__title">Exclusive Bundle Offer</h3>' +
      '<p class="ig-bundle-offer-banner-b__text">' + bodyHtml + '</p>' +
      '</div>';

    return banner;
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.ig-bundle-offer-banner-b{display:none;align-items:center;gap:20px;padding:18px 20px;margin-bottom:0;background:#fff;border:1px solid #e8e8e8;border-radius:4px;font-family:Poppins,Arial,sans-serif}' +
      'body[data-ig-bundle-offer-banner="true"] .ig-bundle-offer-banner-b{display:flex}' +
      'body[data-ig-bundle-offer-banner="true"] .shopify-app-block[id*="sternify_discount_code_box"],' +
      'body[data-ig-bundle-offer-banner="true"] [id*="sternify_discount_code_box"]{display:none!important}' +
      'body:not([data-ig-bundle-offer-banner="true"]) [data-ig-bundle-offer-banner-b]{display:none!important}' +
      '.ig-bundle-offer-banner-b__left{flex:0 0 108px;display:flex;flex-direction:column;align-items:center;text-align:center}' +
      '.ig-bundle-offer-banner-b__icon-wrap{width:56px;height:56px;border-radius:50%;background:#fff;display:flex;align-items:center;justify-content:center;box-shadow: 0px 0px 20px 5px #D92D2033;margin-bottom:10px}' +
      '.ig-bundle-offer-banner-b__icon-wrap img{width:26px;height:26px}' +
      '.ig-bundle-offer-banner-b__stock{display:inline-flex;align-items:center;gap:4px;color:#dd1d1d;font-size:13px;font-weight:600;line-height:1.2;margin-bottom:8px}' +
      '.ig-bundle-offer-banner-b__stock svg{width:14px;height:14px;flex-shrink:0}' +
      '.ig-bundle-offer-banner-b__progress{width:100%;height:6px;border-radius:999px;background:#fde8e8;overflow:hidden}' +
      '.ig-bundle-offer-banner-b__progress-fill{width:18%;height:100%;border-radius:inherit;display:block!important;background:#dd1d1d}' +
      '.ig-bundle-offer-banner-b__right{flex:1;min-width:0}' +
      '.ig-bundle-offer-banner-b__title{margin:0 0 8px;color:#1f2a44;font-size:16px;font-weight:700;letter-spacing:.4px;line-height:1.25;text-transform:uppercase}' +
      '.ig-bundle-offer-banner-b__text{margin:0;color:#4a4a4a;font-size:12px;line-height:1.55}' +
      '.ig-bundle-offer-banner-b__text strong,.ig-bundle-offer-banner-b__text b{color:#dd1d1d;font-weight:700}' +
      '.ig-bundle-offer-banner-b__text em{font-style:normal}' +
      '@media screen and (max-width:749px){.ig-bundle-offer-banner-b{flex-direction:column;align-items:stretch;gap:14px;padding:16px}.ig-bundle-offer-banner-b__left{flex-basis:auto}.ig-bundle-offer-banner-b__title{font-size:15px}}';
    document.head.appendChild(style);
  }

  function mountBanners() {
    getControlBlocks().forEach(function (controlBlock) {
      if (controlBlock.getAttribute(MARK) === '1') return;

      var existing = getBannerForControl(controlBlock);
      if (!existing) {
        existing = buildBanner(controlBlock);
        controlBlock.insertAdjacentElement('afterend', existing);
      }

      controlBlock.setAttribute(MARK, '1');
    });
  }

  function applyState() {
    if (!document.body) return;

    mountBanners();

    var enabled = isTestBEnabled();
    document.querySelectorAll('[data-ig-bundle-offer-banner-b]').forEach(function (banner) {
      banner.setAttribute('aria-hidden', enabled ? 'false' : 'true');
    });

    getControlBlocks().forEach(function (node) {
      node.setAttribute('aria-hidden', enabled ? 'true' : 'false');
    });
  }

  function boot() {
    injectStyles();
    applyState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

  function watchBodyAttribute() {
    if (!document.body) {
      document.addEventListener('DOMContentLoaded', watchBodyAttribute, { once: true });
      return;
    }

    new MutationObserver(function () {
      applyState();
    }).observe(document.body, {
      attributes: true,
      attributeFilter: [ATTR],
      childList: true,
      subtree: true,
    });
  }

  watchBodyAttribute();

  window.IgBundleOfferBanner = {
    enable: function () {
      if (!document.body) return;
      document.body.setAttribute(ATTR, 'true');
      applyState();
    },
    disable: function () {
      if (!document.body) return;
      document.body.removeAttribute(ATTR);
      applyState();
    },
    apply: applyState,
    isTestBEnabled: isTestBEnabled,
  };
})();
